import { isConfigFlagEnabled } from '../config';
import { AVATAR_SERVICE_HOST, AVATAR_SERVICE_VERSION } from '../constants/avatarConstants';
export function getServiceAvatarUrl({ avatar, type, size, trimTransparentPixels }) {
    const baseUrl = `${AVATAR_SERVICE_HOST}/?type=${type}&v=${AVATAR_SERVICE_VERSION}${isConfigFlagEnabled('useParallelAvatarServiceRender') ? '&parallel=true' : ''}${trimTransparentPixels ? '&trim=true' : ''}&size=${size}`;
    switch (avatar.type) {
        case 'custom': {
            const { skin: skinColor, hair: hairColor } = avatar.avatar.properties.colors;
            const customObj = {
                skinColor,
                hairColor,
                ...avatar.avatar.properties.parts
            };
            return `${baseUrl}&custom=${encodeURIComponent(JSON.stringify(customObj))}`;
        }
        case 'legacy': {
            return `${baseUrl}&legacy=${avatar.faceNum}`;
        }
        case 'unique': {
            return `${baseUrl}&unique=${avatar.uniqueAvatarType}`;
        }
    }
}
